import { useContext } from 'react';
import uniqueId from 'lodash-es/uniqueId';

import { ToastDispatchContext } from './context';
import { ToastOptions } from './types';

type AddToastFn = (options: ToastOptions) => void;
type DismissToastFn = (toastId: string) => void;

export const useToast = (): [AddToastFn, DismissToastFn] => {
  const AUTO_CLOSE_MS = 7000;
  const dispatch = useContext(ToastDispatchContext);

  const dismissToast = (toastId: string): void => {
    dispatch({
      type: 'CLOSE_TOAST',
      payload: toastId,
    });
    setTimeout(
      () =>
        dispatch({
          type: 'REMOVE_TOAST',
          payload: toastId,
        }),
      500,
    );
  };

  const addToast = (options: ToastOptions): void => {
    const toastId = options.id ?? uniqueId('toast-');
    let timeout: ReturnType<typeof setTimeout>;

    dispatch({
      type: 'ADD_TOAST',
      payload: {
        ...options,
        open: true,
        id: toastId,
        onDismiss: () => {
          clearTimeout(timeout);
          dismissToast(toastId);
          options.onDismiss?.();
        },
      },
    });
    const persistent: boolean = options.isDropZone ?? false; // drop zone has persistent toast
    if (!persistent) {
      timeout = setTimeout(dismissToast, AUTO_CLOSE_MS, toastId);
    }
  };

  return [addToast, dismissToast];
};
